import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { CountsApiAdapter } from '../adapters/CountsApiAdapter';

interface UseLogisticStatusCountsProps {
  searchFilter?: {
    filters: Array<{ column: string; operator: string; value?: unknown }>;
    logic: string;
  };
}

export const useLogisticStatusCounts = ({ searchFilter }: UseLogisticStatusCountsProps = {}) => {
  const countsAdapter = new CountsApiAdapter(createHttpClient(apiClientWH));

  const {
    data: counts = {
      all: 0,
      no_logistic_status: 0,
      in_transit: 0,
      in_delivery: 0,
      pickup_point: 0,
      delivered: 0,
      returned_to_sender: 0,
    },
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['logisticStatusCounts', searchFilter],
    queryFn: () => countsAdapter.getAllLogisticStatusCounts(searchFilter),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    counts,
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
